import type React from 'react'

/**
 * Box for a guided-signing card (Part 1 above the report, Part 2 before the
 * contract): exactly as wide as the report's page column.
 *
 * 13234371965 (Jaron's iPhone, Oct 29): with the contract-company dropdown
 * open the Part 1 card collapsed to a ~50px strip, one word per line. The
 * report is wider than a phone and has no initial-scale, so the browser zooms
 * it out: `innerWidth` (~800) is about twice `documentElement.clientWidth`
 * (~400). MUI's Modal scroll lock takes that difference as the "scrollbar
 * width" and adds it to `body` as padding-right (~400px), so every auto-width
 * block in the body had zero room left. Part 2 had a second problem: it sits
 * in the report container (flex column, align-items: center), so an
 * auto-width box shrank to its content (~217px, iPad and desktop included).
 *
 * A fixed width taken from the page column depends on neither, so the card
 * lines up with the pages on every screen. `display: none` keeps both cards
 * out of the PDF capture, as before.
 */
export function signingCardSlotStyle(
  columnWidth: number,
  hidden: boolean,
): React.CSSProperties {
  return {
    display: hidden ? 'none' : undefined,
    margin: '0 auto',
    maxWidth: 'none',
    width: columnWidth,
  }
}
